export enum FeedbackStatus {
  PENDING = 'PENDING',
  SUBMITTED = 'SUBMITTED',
  UPDATED = 'UPDATED',
  FINALIZED = 'FINALIZED'
}

export interface FeedbackRequest {
  overallRating: number;
  serviceQualityRating: number;
  punctualityRating: number;
  communicationRating: number;
  comment?: string;
  agentFeedbacks: AgentFeedbackRequest[];
}

export interface AgentFeedbackRequest {
  agentId: number;
  professionalismRating: number;
  attitudeRating: number;
  efficiencyRating: number;
  comment?: string;
}

export interface FeedbackResponse {
  id: number;
  reservationId: number;
  reservationTitle: string;
  overallRating: number;
  serviceQualityRating: number;
  punctualityRating: number;
  communicationRating: number;
  comment?: string;
  status: FeedbackStatus;
  updateCount: number;
  submittedAt?: string;
  createdAt: string;
  updatedAt: string;
  agentFeedbacks: AgentFeedbackResponse[];
}

export interface AgentFeedbackResponse {
  id: number;
  agentId: number;
  agentName: string;
  agentEmail: string;
  profileImage: string;
  professionalismRating: number;
  attitudeRating: number;
  efficiencyRating: number;
  comment?: string;
  createdAt: string;
}

export interface FeedbackSearchCriteria {
  reservationId?: number;
  status?: FeedbackStatus;
  startDate?: string;
  endDate?: string;
}

// for forms
export interface FeedbackFormData {
  overallRating: number;
  serviceQualityRating: number;
  punctualityRating: number;
  communicationRating: number;
  comment: string;
  agentFeedbacks: AgentFeedbackFormData[];
}

export interface AgentFeedbackFormData {
  agentId: number;
  agentName: string;
  professionalismRating: number;
  attitudeRating: number;
  efficiencyRating: number;
  comment: string;
}

// display purposes
export const FeedbackStatusLabels = {
  [FeedbackStatus.PENDING]: 'En attente',
  [FeedbackStatus.SUBMITTED]: 'Soumis',
  [FeedbackStatus.UPDATED]: 'Mis à jour',
  [FeedbackStatus.FINALIZED]: 'Finalisé'
};

export const FeedbackStatusColors = {
  [FeedbackStatus.PENDING]: '#ffc107',
  [FeedbackStatus.SUBMITTED]: '#28a745',
  [FeedbackStatus.UPDATED]: '#17a2b8',
  [FeedbackStatus.FINALIZED]: '#6c757d'
};

export const RatingLabels = {
  1: 'Très insatisfait',
  2: 'Insatisfait',
  3: 'Neutre',
  4: 'Satisfait',
  5: 'Très satisfait'
};